<script>
import Auth from "../../layouts/auth-2";
import appConfig from "../../../../app.config";

/**
 * Login-2 component
 */
export default {
  components: {
    Auth,
  },
  page: {
    title: "登入管理後台",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data () {
    return {
      account: "",
      password: "",
      isLoading: false,
      errorMessage: ""
    };
  },
  methods: {
    async authLogin () {
      // 驗證輸入
      if (!this.account || !this.password) {
        this.errorMessage = "請填入帳號和密碼"
        return
      }

      // 驗證 Email 格式
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.account)) {
        this.errorMessage = "請輸入有效的 Email 格式"
        return
      }

      this.isLoading = true
      this.errorMessage = ""

      try {
        // 調用後端登入 API
        await this.$root.apis.login({
          email: this.account,
          password: this.password
        }, (response) => {
          this.isLoading = false
          
          if (response.body.success) {
            // 儲存 Token
            this.$root.common.setCookie("api-token", response.body.data.token)
            
            // 儲存使用者資訊
            this.$root.common.setCookie("user", JSON.stringify(response.body.data.user))
            
            this.$root.login = true
            this.$root.common.setCookie("login", true)

            // 跳轉到首頁
            this.$router.push("/")
          } else {
            this.errorMessage = response.body.message || "登入失敗"
          }
        }, (error) => {
          this.isLoading = false
          console.error("登入錯誤:", error)
          
          // 處理不同類型的錯誤
          if (error.status === 401) {
            this.errorMessage = "Email 或密碼錯誤"
          } else if (error.status === 403) {
            this.errorMessage = error.body?.message || "帳號已被停用，請聯繫管理員"
          } else if (error.body?.message) {
            this.errorMessage = error.body.message
          } else if (error.body?.error) {
            this.errorMessage = error.body.error
          } else {
            this.errorMessage = "登入失敗，請稍後再試"
          }
        })
      } catch (error) {
        this.isLoading = false
        console.error("登入異常:", error)
        this.errorMessage = "登入失敗，請稍後再試"
      }
    }
  }
};
</script>

<template>
  <Auth>
    <!-- Logo -->
    <div class="auth-brand text-center text-lg-left">
      <div class="auth-logo">
        <router-link to="/" class="logo logo-dark text-center">
          <span class="logo-lg">
            <img src="@/assets/images/logo-dark.png" alt height="60" />
          </span>
        </router-link>

        <router-link to="/" class="logo logo-light text-center">
          <span class="logo-lg">
            <img src="@/assets/images/logo-light.png" alt height="60" />
          </span>
        </router-link>
      </div>
    </div>

    <!-- title-->
    <h4 class="mt-0">登入</h4>
    <p class="text-muted mb-4">
      請輸入您的 Email 與 密碼
    </p>

    <!-- form -->
    <form action="#">
      <div class="form-group">
        <label for="emailaddress">Email 帳號</label>
        <input class="form-control" type="email" id="emailaddress" required placeholder="請輸入您的 email"
          v-model="account" />
      </div>
      <div class="form-group">
        <!-- <router-link to="/auth/recoverpwd-2" class="text-muted float-right">
          <small>Forgot your password?</small>
        </router-link> -->
        <label for="password">密碼</label>
        <div class="input-group input-group-merge">
          <input type="password" id="password" class="form-control" placeholder="請輸入您的密碼" v-model="password" />
          <div class="input-group-append" data-password="false">
            <div class="input-group-text">
              <span class="password-eye"></span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="form-group mb-3">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="checkbox-signin" />
          <label class="custom-control-label" for="checkbox-signin">Remember me</label>
        </div>
      </div> -->
      <!-- 錯誤訊息 -->
      <div v-if="errorMessage" class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>

      <div class="form-group mb-0 text-center">
        <button 
          class="btn btn-primary btn-block" 
          type="button" 
          @click="authLogin"
          :disabled="isLoading">
          <span v-if="isLoading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
          {{ isLoading ? '登入中...' : '登入' }}
        </button>
      </div>
      <!-- social -->
      <!-- <div class="text-center mt-4">
        <h5 class="mt-0 text-muted">Sign in with</h5>
        <ul class="social-list list-inline mt-3 mb-0">
          <li class="list-inline-item">
            <a href="javascript: void(0);" class="social-list-item border-purple text-purple">
              <i class="mdi mdi-facebook"></i>
            </a>
          </li>
          <li class="list-inline-item">
            <a href="javascript: void(0);" class="social-list-item border-danger text-danger">
              <i class="mdi mdi-google"></i>
            </a>
          </li>
          <li class="list-inline-item">
            <a href="javascript: void(0);" class="social-list-item border-info text-info">
              <i class="mdi mdi-twitter"></i>
            </a>
          </li>
          <li class="list-inline-item">
            <a href="javascript: void(0);" class="social-list-item border-secondary text-secondary">
              <i class="mdi mdi-github"></i>
            </a>
          </li>
        </ul>
      </div> -->
    </form>
    <!-- end form-->
    <!-- Footer-->
    <footer class="footer footer-alt">
      <!-- <p class="text-muted">
        Don't have an account?
        <router-link to="/auth/register-2" class="text-primary ml-1">
          <b>Sign Up</b>
        </router-link>
      </p> -->
    </footer>
  </Auth>
</template>
